import "../../css/pageLayout.css"
import { parseJsonField } from "../../utils/parseJsonField";

function SpacerSection({ section }) {
  const settings = parseJsonField(section.settings_json);

  return (
    <div
      className="spacer-section"
      style={{ height: settings.height || "40px" }}
    />
  );
}

export default SpacerSection;